module.exports = __webpack_public_path__ + "static/Logo-e0a8ab412d9b71ce7da6a724656114b8.png";